"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSelectCarList = void 0;
var react_1 = __importDefault(require("react"));
var ModalSelectList_module_scss_1 = __importDefault(require("./ModalSelectList.module.scss"));
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var CardAuto_1 = require("../cardAuto/CardAuto");
var Loader_1 = require("../loader/Loader");
var ModalSelectCarList = function () {
    var isLoad = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.stateLoad.isLoad;
    var error = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.stateLoad.error;
    var carList = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carList;
    if (isLoad) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Loader_1.Loader, null)));
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043C\u0430\u0448\u0438\u043D");
    }
    return (react_1.default.createElement("div", { className: ModalSelectList_module_scss_1.default.modal_select__list }, carList.map(function (car) {
        return react_1.default.createElement(CardAuto_1.CardAuto, __assign({ key: car.id }, car, { inModalSelect: true }));
    })));
};
exports.ModalSelectCarList = ModalSelectCarList;
